import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { analyticsConfigured, openConsentSettings } from "@/lib/analytics";

export const Footer = () => {
  const { t, lang } = useLang();
  return (
    <footer className="mt-20 bg-brand-navy text-slate-300">
      <div className="vlx-container py-12 lg:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2 lg:pr-10">
            <div className="flex items-center gap-2.5">
              <img
                src="/valuelix-icon-192.png"
                alt=""
                style={{ height: "48px", width: "48px" }}
                className="shrink-0 rounded-full object-cover ring-2 ring-white/20"
              />
              <div className="leading-tight">
                <span className="block font-display text-2xl font-extrabold text-white">Valuelix</span>
                <span className="block text-sm font-medium text-sky-300">valuelix.com</span>
              </div>
            </div>
            <p className="mt-3 text-sm font-medium text-sky-300">{t("footer_tagline")}</p>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-400">{t("footer_desc")}</p>
            <p className="mt-4 max-w-md rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-xs leading-relaxed text-slate-400">
              {t("footer_disclaimer")}
            </p>
          </div>

          <div>
            <h2 className="font-display text-sm font-bold uppercase tracking-wider text-white">{t("footer_quick")}</h2>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link data-testid="footer-home" to="/" className="text-slate-400 transition-colors hover:text-white">{t("nav_home")}</Link></li>
              <li><Link data-testid="footer-about" to="/about" className="text-slate-400 transition-colors hover:text-white">{t("footer_about")}</Link></li>
              <li><Link data-testid="footer-contact" to="/contact" className="text-slate-400 transition-colors hover:text-white">{t("footer_contact")}</Link></li>
              <li><Link data-testid="footer-dealers" to="/dealers" className="text-slate-400 transition-colors hover:text-white">{t("nav_dealers")}</Link></li>
              <li><Link data-testid="footer-my-offers" to="/my-offers" className="text-slate-400 transition-colors hover:text-white">{t("mo_title")}</Link></li>
              <li><Link data-testid="footer-how-calc" to="/how-we-calculate" className="text-slate-400 transition-colors hover:text-white">{t("how_calc_link")}</Link></li>
              {/* plain links: these pages are static HTML files */}
              <li><a data-testid="footer-resale-prices" href={lang === "hi" ? "/hi/resale-price/" : "/resale-price/"} className="text-slate-400 transition-colors hover:text-white">{t("footer_resale_prices")}</a></li>
              <li><a data-testid="footer-guides" href={lang === "hi" ? "/hi/guides/" : "/guides/"} className="text-slate-400 transition-colors hover:text-white">{t("footer_guides")}</a></li>
            </ul>
          </div>

          <div>
            <h2 className="font-display text-sm font-bold uppercase tracking-wider text-white">{t("footer_legal")}</h2>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link data-testid="footer-terms" to="/terms" className="text-slate-400 transition-colors hover:text-white">{t("footer_terms")}</Link></li>
              <li><Link data-testid="footer-privacy" to="/privacy" className="text-slate-400 transition-colors hover:text-white">{t("footer_privacy")}</Link></li>
              <li><Link data-testid="footer-disclaimer" to="/disclaimer" className="text-slate-400 transition-colors hover:text-white">{t("nav_disclaimer")}</Link></li>
              {analyticsConfigured() && (
                <li><button data-testid="footer-cookie-settings" onClick={openConsentSettings} className="text-slate-400 transition-colors hover:text-white">{t("cookie_settings")}</button></li>
              )}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6 text-center text-xs text-slate-400">
          © {new Date().getFullYear()} Valuelix. {t("footer_rights")}
        </div>
      </div>
    </footer>
  );
};
